import {
  ActionReducerMap,
  ActionReducer,
  MetaReducer,
  Action,
} from '@ngrx/store';
import { storeLogger } from 'ngrx-store-logger';
import { CORE_ACTION } from './core.actions';

export function logger(reducer: ActionReducer<any>): any {
  return storeLogger()(reducer);
}
// MMMW2-5810 TODO: add this meta reducer after refactoring the scope of services
export function logout(reducer: ActionReducer<any>): any {
  return function(state: any, action: Action) {
    return reducer(
      action.type === CORE_ACTION.DIRECT_USER_LOGGED_OUT
        ? {
            loginReducer: {
              ...state.loginReducer,
              userSignedIn: false,
              status: 0,
              uiState: 0,
            },
          }
        : state,
      action
    );
  };
}

/**
 * Our state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const reducers: ActionReducerMap<any> = {};

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const metaReducers: MetaReducer<any>[] = [logger];
